import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "ADD_SHARE", {
  BUTTON_TEXT: "Add share campaigns",
});
